import { render, staticRenderFns } from "./ScenicSpotContent.vue?vue&type=template&id=3955018e&scoped=true&"
import script from "./ScenicSpotContent.vue?vue&type=script&lang=js&"
export * from "./ScenicSpotContent.vue?vue&type=script&lang=js&"
import style0 from "./ScenicSpotContent.vue?vue&type=style&index=0&id=3955018e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3955018e",
  null
  
)

export default component.exports